// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor {
  margin-bottom: "50px" !important;
}

.ql-editor {
  height: "5rem" !important;
}

.ql-container {
  height: 100px !important;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Editor/style.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".text-editor {\n  margin-bottom: \"50px\" !important;\n}\n\n.ql-editor {\n  height: \"5rem\" !important;\n}\n\n.ql-container {\n  height: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
